/* DEMO (29 Oct): two small product page touches. (1) a quiet reassurance row under BUY NOW (free delivery, secure checkout, Feefo) - three even columns, icon above text, so it never wraps onto an orphan second line; (2) the 'Hover to zoom' label fades away after a few seconds so it stops covering the picture. (The blank space kept for the bigger-sizes strip stays blank.) Undo = remove its script line in snippets/dc-sizes.liquid. */
(function () {
  'use strict';
  var det = document.getElementById('product-details');
  if (!det) return;
  function $(s, r) { return (r || document).querySelector(s); }

  var css = document.createElement('style');
  css.textContent =
    '.dc-trust{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:6px;margin:14px 0 0;padding:10px 8px;background:#f6efe4;border-radius:12px;color:#392919;font:700 12px/1.25 Arial,Helvetica,sans-serif;text-align:center}' +
    '.dc-trust a,.dc-trust span{display:flex;flex-direction:column;align-items:center;justify-content:flex-start;gap:5px;padding:2px 4px;color:#392919;text-decoration:none}' +
    '.dc-trust > *+*{border-left:1px solid #e3d6c1}' +
    '.dc-trust a:hover{text-decoration:underline}' +
    '.dc-trust i{color:#eb6035;font-size:18px;line-height:1}' +
    '@media(min-width:768px){.dc-trust{font-size:13px}}' +
    '.dc-hint.dc-gone{opacity:0!important}';
  document.head.appendChild(css);

  /* 1. reassurance row under BUY NOW */
  function trust() {
    if ($('.dc-trust', det)) return true;
    var form = $('#AddToCartForm', det);
    if (!form || !form.parentNode) return false;
    var row = document.createElement('div');
    row.className = 'dc-trust';
    row.innerHTML =
      '<a href="/pages/our-delivery"><i class="fa fa-truck" aria-hidden="true"></i>Free delivery over &pound;70</a>' +
      '<span><i class="fa fa-lock" aria-hidden="true"></i>Secure checkout</span>' +
      '<a href="/pages/discount-coffee-reviews"><i class="fa fa-star" aria-hidden="true"></i>Rated Excellent on Feefo</a>';
    form.parentNode.insertBefore(row, form.nextSibling);
    return true;
  }

  /* 2. the zoom label fades away */
  function hint() {
    var h = $('#product-images .dc-hint');
    if (!h || h.getAttribute('data-dc')) return;
    h.setAttribute('data-dc', '1');
    setTimeout(function () { h.classList.add('dc-gone'); }, 4000);
  }

  var tries = 0;
  (function run() {
    trust(); hint();
    if (++tries < 12) setTimeout(run, 400);
  })();
})();